import type { QueryKey } from '@tanstack/react-query';
import {
  getIsPrimary,
  getPrimaryCount,
  type OnSetPrimaryInvalidator,
} from '../NarrativeInvalidationBoundary';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import type { useNarrativeWeeklyPicks } from './hooks/useNarrativeWeeklyPicks';

export const handleOnSetPrimary =
  (queryKey: QueryKey): OnSetPrimaryInvalidator =>
  ({ queryClient, invalidateExcept }, actionPayload) => {
    invalidateExcept(['narrative-weekly-picks']);
    queryClient.setQueryData<ResolvedQueryData<typeof useNarrativeWeeklyPicks>>(
      queryKey,
      (state) => {
        if (!state?.narrativeWeeklyPicks) return;

        return {
          ...state,
          narrativeWeeklyPicks: state.narrativeWeeklyPicks.map((narrative) => ({
            ...narrative,
            isPrimary: getIsPrimary(narrative, actionPayload),
            primaryCount: getPrimaryCount(narrative, actionPayload),
          })),
        };
      }
    );
  };
